import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {DialogRef} from '@progress/kendo-angular-dialog';
import {take} from "rxjs/operators";
import {SharedValidators} from "../../shared/shared-validators";
import {DtoCountry} from "../../shared/models/DtoCountry";
import {FormService} from "../../../fw/services/form.service";
import {EmployeeService} from "./employee.service";
import {SharedDataService} from "../../shared/shared-data.service";
import {SharedService} from "../../shared/shared.service";
import {ValidationMessageComponent} from "../../shared/validation-message.component";
import {DtoEmployeeCreate} from "./models/DtoEmployeeCreate";
import {Router} from "@angular/router";

@Component({
    selector: 'ngx-employee-create',
    template: require('./employee-create.component.html'),
    styles: [require('./employee-create.component.css')]
})

export class EmployeeCreateComponent implements OnInit, OnDestroy {
    @Input() dialog: DialogRef;
    @ViewChild('validationMessage', {static: false}) validationMessage: ValidationMessageComponent;
    form: FormGroup = this.fb.group({
        zipcode: [null, [SharedValidators.customRequired]],
        houseNo: [null, [SharedValidators.customRequired]],
        countryId: [1, [SharedValidators.customRequired]],
        lastName: [null, [SharedValidators.customRequired]],
        initials: null,
        infix: null,
        firstName: null
    });
    countries: DtoCountry[];

    constructor(
        private fb: FormBuilder,
        private fs: FormService,
        public ds: EmployeeService,
        private sds: SharedDataService,
        private router: Router,
        public ss: SharedService
    ) {
    }

    ngOnInit() {
        this.form.valueChanges.subscribe(() => {
                if (this.validationMessage) this.validationMessage.getFormValidationErrors();
            }
        );

        this.sds.getCountries().subscribe((res: DtoCountry[]) => {
            this.countries = res;
        });
    }

    ngOnDestroy() {
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        this.validationMessage.validateForm();

        if (this.form.valid) {
            this.ds.createEmployee({
                countryId: this.form.get('countryId').value,
                houseNo: this.form.get('houseNo').value,
                zipcode: this.form.get('zipcode').value,
                initials: this.form.get('initials').value,
                firstName: this.form.get('firstName').value,
                infix: this.form.get('infix').value,
                lastName: this.form.get('lastName').value
            } as DtoEmployeeCreate).pipe(take(1)).subscribe(res => {
                if (res.hasError) this.ss.message(res.errorMessage);
                else {
                    this.router.navigate(['/auth/employee', res.id]);
                    this.closeWindow(true);
                }
            });
        }
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/employees/employee-details/employee-create.component.ts